import { render, staticRenderFns } from "./gameSelect4.vue?vue&type=template&id=8d423afa&scoped=true"
import script from "./gameSelect4.vue?vue&type=script&lang=js"
export * from "./gameSelect4.vue?vue&type=script&lang=js"
import style0 from "./gameSelect4.vue?vue&type=style&index=0&id=8d423afa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d423afa",
  null
  
)

export default component.exports